import React, { useEffect, useState } from "react";

function formatEuro(value) {
  if (value === null || value === undefined || value === "") return "";

  const number = Number(value);

  if (isNaN(number)) return "";

  return number.toLocaleString("it-IT", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}

function parseEuro(value) {
  if (!value) return "";

  // rimuove €
  let v = value.replace("€", "").trim();

  // rimuove separatori migliaia
  v = v.replace(/\./g, "");

  // converte virgola in punto
  v = v.replace(",", ".");

  const number = Number(v);

  return isNaN(number) ? "" : number;
}

export default function EuroInput({
  label,
  name,
  value,
  onChange,
  placeholder = "0,00",
  disabled = false,
  required = false,
  width = "200px"
}) {

  const [display, setDisplay] = useState("");

  useEffect(() => {
    setDisplay(formatEuro(value));
  }, [value]);

  function handleChange(e) {
    const raw = e.target.value;

    setDisplay(raw);

    const parsed = parseEuro(raw);

    onChange?.({
      target: {
        name,
        value: parsed
      }
    });
  }

  function handleBlur() {
    const parsed = parseEuro(display);
    setDisplay(formatEuro(parsed));
  }

  function handleFocus() {
    if (!display) return;

    const parsed = parseEuro(display);
    setDisplay(parsed.toString().replace(".", ","));
  }

  return (
    <label style={{ display: "grid", gap: 6 }}>
      {label && (
        <span style={{ color: "white" }}>
          {label}
          {required && <span style={{ color: "#ef4444" }}> *</span>}
        </span>
      )}

      <div style={{
        display: "flex",
        alignItems: "center",
        borderRadius: 10,
        border: "1px solid rgba(255,255,255,0.15)",
        background: "linear-gradient(180deg, #1f2937 0%, #111827 100%)",
        boxShadow: "inset 0 1px 2px rgba(0,0,0,0.4)",
        padding: "0 10px"
      }}>

        <span style={{
          color: "rgba(255,255,255,0.7)",
          marginRight: 6
        }}>
          €
        </span>

        <input
          type="text"
          name={name}
          value={display}
          onChange={handleChange}
          onBlur={handleBlur}
          onFocus={handleFocus}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            width,
            padding: "8px 0",
            border: "none",
            outline: "none",
            background: "transparent",
            color: "white",
            fontSize: 14,
            fontFamily: "inherit"
          }}
        />
      </div>
    </label>
  );
}